import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-205" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-4xl px-5" data-id="element-206" data-mp="1t8niy08x17ou">
        <dl className="grid grid-cols-3" data-id="element-207" data-mp="1oac9hqmj8z75">
          {stats.map((stat, index) => <div key={stat.label} className={`px-3 text-center ${index > 0 ? 'border-l border-ink/10' : ''}`} data-id="element-208" data-mp="1jcu05z4lshym" data-mpi={index}>
              <dt className="sr-only" data-id="element-209" data-mp="1efbx2pd9owyj">{stat.label}</dt>
              <dd data-id="element-210" data-mp="19m94okk87tjx">
                <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-211" data-mp="19lpl6zexgx3s">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50 sm:text-xs" data-id="element-212" data-mp="10lsxp149y4ab">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}